import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchEventLivePrices, deleteEventLivePrice } from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from 'components/helpers/columns/prices';

// Import components
import { TableTemplate } from 'components/common/templates';

const EventsLivePrices = ({
	error,
	fetchEventLivePrices,
	deleteEventLivePrice,
	resources,
	match: {
		params: { id }
	}
}) => {
	const { t } = useTranslation();

	return (
		// Dispatch fetchEventLivePrices, deleteEventLivePrice action in events_live_prices
		<TableTemplate
			itemId={id}
			error={error}
			type={`events_live/${id}/price`}
			typeText="prices"
			addLinkText={t('prices:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchEventLivePrices}
			deleteItemAction={deleteEventLivePrice}
			notificationDeleteSuccessTxt={t('prices:notification.delete_success')}
			notificationDeleteErrorTxt={t('prices:notification.delete_error')}
		></TableTemplate>
	);
};

EventsLivePrices.propTypes = {
	error: PropTypes.bool.isRequired,
	resources: PropTypes.object.isRequired,
	fetchEventLivePrices: PropTypes.func.isRequired,
	deleteEventLivePrice: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({ id: PropTypes.string.isRequired })
	})
};

const mapStateToProps = ({ events_live: { prices } }) => ({
	error: prices.error,
	resources: prices
});

export default compose(
	connect(mapStateToProps, { fetchEventLivePrices, deleteEventLivePrice }),
	withRouter
)(EventsLivePrices);
